import { render, staticRenderFns } from "./ApprovalImageProfile.vue?vue&type=template&id=c2a722c4&"
import script from "./ApprovalImageProfile.vue?vue&type=script&lang=js&"
export * from "./ApprovalImageProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports